import { render } from "./research-content.vue?vue&type=template&id=0174881e&scoped=true"
import script from "./research-content.vue?vue&type=script&lang=js"
export * from "./research-content.vue?vue&type=script&lang=js"

import "./research-content.vue?vue&type=style&index=0&id=0174881e&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/hkust-gz-vitals/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0174881e"]])

export default __exports__